export default function getIndianCurrencyFormat(
  num: string | number,
  withDecimals: boolean = false
) {
  if (typeof num !== "number") {
    num = parseFloat(num);
  }
  const roundedNumberString = String(
    withDecimals ? num.toFixed(2) : Math.round(num)
  );
  const [intPart, dec] = roundedNumberString.split(".");
  const integer = intPart.replace(/(\d)(?=(\d\d)+\d$)/g, "$1,");
  return withDecimals ? integer + "." + dec : integer;
}

export function getIndianCurrencyFormatForMaskedPrice(
  num?: string | number | null,
  withDecimals: boolean = false
) {
  if (num === null || num === undefined || num === "") {
    return "";
  }

  const value = String(num).trim();

  if (!value) {
    return "";
  }

  const [intPart, decPart] = value.split(".");

  if (!intPart || !/^\d+$/.test(intPart)) {
    return "";
  }

  const formattedInt = intPart.replace(/(\d)(?=(\d\d)+\d$)/g, "$1,");

  const maskedInt = formattedInt.replace(/\d(?=.*,\d{3}$)/g, "X");

  return withDecimals && decPart
    ? `${maskedInt}.${decPart}`
    : maskedInt;
}

export function getPrice(amount: number, form?: string): string {
  if (amount >= 10000000)
    return (
      (amount / 10000000).toFixed(2) +
      (form === "full" ? " Cr" : form === "half" ? " Cr" : " ")
    );
  else if (amount >= 100000)
    return (
      (amount / 100000).toFixed(2) +
      (form === "full" ? "lakh" : form === "half" ? " L" : " ")
    );
  else if (amount >= 1000)
    return (
      (amount / 1000).toFixed(2) +
      (form === "full" ? " K" : form === "half" ? " K" : " ")
    );
  return amount.toString();
}

export function getShortFormat(amount: number, form: string) {
  if (amount >= 10000000) {
    return (
      (amount / 10000000).toFixed(1) +
      (form === "full" ? " Cr" : form === "half" ? " Cr" : "")
    );
  } else if (amount >= 100000) {
    return (
      (amount / 100000).toFixed(1) +
      (form === "full" ? " lakh" : form === "half" ? " L" : "")
    );
  } else if (amount >= 1000) {
    return (
      (amount / 1000).toFixed(1) +
      (form === "full" ? " K" : form === "half" ? " K" : "")
    );
  }

  return amount.toString(); // fallback for < 1000
}
